<template>
  <div :class="$style.contentBox">
    <div :class="$style.buttonBox" style="padding-top: 20px;">
      <van-button :class="[$style.buttonPrimary,$style.b]" @click="handleClick(1)" v-if="dataList && dataList.length<31">
        {{ $t('common.Declare') }}
      </van-button>
    </div>
    <common-title>{{ $t('common.Pleaseselectthefiler') }}</common-title>
    <van-radio-group v-model="result" :class="$style.ItemListBox">
      <van-collapse v-model="activeNames">
        <van-collapse-item
          :class="$style.ItemList"
          v-for="(item,index) in dataList"
          :key="item.id"
          :name="index">
          <template #title>
            <van-radio
              :class="$style.Items"
              :name="index"
              @click.stop="handlecc(index)"/>
            <div :class="$style.ItemsName">
              {{ $t('common.Name') }}：{{ item.name.length > 4 ? `${item.name.substring(0,4)}...` : item.name }}
            </div>
            <div :class="$style.timeItems">{{ new Date(item.time) | time }}</div>
          </template>
          <img :src="item.QRcode" :style="(item.status === 6 || item.status === 3) ? 'opacity: 0.5;' : ''"/>
          <div class="code" v-if="item.status === 6 || item.status === 3">{{ $t('common.failureCode') }}</div>
        </van-collapse-item>
      </van-collapse>
    </van-radio-group>
    <div :class="$style.buttonBox">
      <!-- <van-button :class="$style.buttonPrimary" @click="handleClick(1)" v-if="dataList.length<10">
        新增
      </van-button> -->
      <!-- <van-button :class="$style.buttonPrimary" @click="handleClick(2)">
        編輯
      </van-button> -->
      <!-- <van-button :class="$style.buttonInfo" @click="handleClick(3)">
        刪除
      </van-button> -->
      <van-button :class="[$style.buttonPrimary,$style.b]" @click="handleClick" v-if="dataList && dataList.length<31">
        {{ $t('common.Declares') }}
      </van-button>
      <van-button :class="$style.buttonInfo" @click="handleDle">
        {{ $t('common.Delete') }}
      </van-button>
    </div>
  </div>
</template>

<script>
  import { Button, Collapse, CollapseItem, RadioGroup, Radio, Dialog, Notify} from "vant";
  import { commonTitle } from "./components";
  import api from "../../api";
  // eslint-disable-next-line no-unused-vars
  import { time } from "../../filters";
  export default {
    name: "Mobile",
    components: {
      "van-button": Button,
      "van-collapse": Collapse,
      "van-collapse-item": CollapseItem,
      "van-radio": Radio,
      "van-radio-group": RadioGroup,
      commonTitle
    },
    data () {
      return {
        doalogShow: false,
        dataList: [],
        activeNames: [],
        result: "",
        data: ""
      };
    },
    methods: {
      handlecc (e) {
        if (this.activeNames.findIndex(item => item === e) !== -1) {
          this.activeNames.splice(this.activeNames.findIndex(item => item === e), 1);
        } else {
          this.activeNames.push(e);
        }
        if (this.data === e) {
          this.result = "";
          this.data = "";
        } else {
          this.data = e;
        }
      },
      handleClick (type) {
        // console.log(this.result);
        // return;
        if (type === 1) {
          if (this.$route.path !== "/eDCBNI/mobile/Declaration") {
            this.$router.push({path: "/eDCBNI/mobile/Declaration"});
          }
          return;
        }
        if (this.result !== "") {
          if (this.$route.path !== "/eDCBNI/mobile/Declaration") {
            this.$router.push({path: "/eDCBNI/mobile/Declaration", query: {index: this.result + 1}});
          }
          return;
        }
        if (this.result === "") {
          Notify({ type: "warning", message: this.$t("common.tis") });
          return;
        }
        // if (this.result === "") {
        //   if (this.dataList.length < 31) {this.$router.push({path: "/eDCBNI/mobile/Declaration"});} else {
        //     Notify({ type: "warning", message: this.$t("common.Youcansaveuptotenrecords") });
        //   }
        // } else {
        //   this.$router.push({path: "/eDCBNI/mobile/Declaration", query: {index: this.result + 1}});
        // }
      },
      handleDle () {
        if (this.result === "") {
          Notify({ type: "warning", message: this.$t("common.Pleasechoosetodeletetheitem") });
        } else {
          Dialog.confirm({
            title: `${this.$t("common.warn")}`,
            message: `${this.$t("common.confirmDelete")}`,
            confirmButtonText: `${this.$t("common.confirm")}`,
            cancelButtonText: this.$t("common.cancel")
          }).then(() => {
            const pageData = JSON.parse(localStorage.getItem("pageData"));
            pageData.splice(this.result, 1);
            localStorage.setItem("pageData", JSON.stringify(pageData));
            Notify({ type: "success", message: this.$t("common.Thedeletionwassuccessful") });
            this.dataList = JSON.parse(localStorage.getItem("pageData"));
            this.result = "";
          });
        }
      }
      // handleClick (type) {
      //   switch (type) {
      //   case 1 : {
      //     this.$router.push({path: "/mobile/Declaration"});
      //     break;
      //   }
      //   case 2 : {
      //     this.$router.push({path: "/mobile/Declaration", query: {index: this.result + 1}});
      //     break;
      //   }
      //   case 3 : {
      //     Dialog.confirm({
      //       title: "提示",
      //       message: "是否確認刪除"
      //     }).then(() => {
      //       const pageData = JSON.parse(localStorage.getItem("pageData"));
      //       pageData.splice(this.result, 1);
      //       localStorage.setItem("pageData", JSON.stringify(pageData));
      //       Notify({ type: "success", message: "刪除成功" });
      //       this.dataList = JSON.parse(localStorage.getItem("pageData"));
      //       this.result = 0;
      //     });
      //     break;
      //   }
      //   }
      // }
    },
    mounted () {
      if (JSON.parse(localStorage.getItem("pageData"))) {
        let id = "";
        JSON.parse(localStorage.getItem("pageData")).forEach(item => {
          id += item.id + ",";
        });
        api.getCashInfo(id.substr(0, id.length - 1)).then(res => {
          const arr = JSON.parse(localStorage.getItem("pageData"));
          res.forEach(item => {
            arr.forEach(val => {
              if (item.id === val.id) {
                val.status = item.status;
                val.remove = item.remove;
              }
            });
          });
          this.dataList = arr.sort((a, b) => {
            return a.submitTime < b.submitTime ? 1 : -1;
          });
          localStorage.setItem("pageData", JSON.stringify(this.dataList));
          this.dataList = JSON.parse(localStorage.getItem("pageData"));
          // console.log(this.dataList);
        });
      }

    }
  };
</script>


<style lang="scss" module src="./style.scss">
</style>
<style>
.van-cell__title {
  display: flex;
  align-items: center;
}
.van-collapse-item__content {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.code {
  height: 50px;
  background: #ccc;
  padding: 0 20px;
  border-radius: 4px;
  color: #fff;
  line-height: 50px;
  margin-top: 16px;
}
</style>